export enum EvaluationOptions {
    APPROVED = 'Approve completion',
    REJECTED = 'Reject completion',
}
